define('lq/services/mpa/issueTracking',[
    'lq/runtimeDropPicker'
], function (RuntimeDropPicker) {
    'use strict';
    
    var shortCutKey = 16; // Shift
    var delta = 500;

    function IssueTracking(annotations) {
        this.configuration = annotations.data;
        this.previousKeyPressTime = null;
        this.presses = 0;
        this.picking = false;
    };

    IssueTracking.typeName = 'IssueTracking';

    IssueTracking.prototype.initialize = function () {
        $(document).on('keyup', this.handleKeyUp.bind(this));
    };

    IssueTracking.prototype.handleKeyUp = function (event) {
        if (event.keyCode !== shortCutKey || this.picking)
            return;

        var keyPressTime = new Date();

        if (this.previousKeyPressTime && keyPressTime - this.previousKeyPressTime > delta) {
            this.presses = 1;
            this.previousKeyPressTime = keyPressTime;
        } else if (this.presses === 2) {
            this.presses = 0;
            this.previousKeyPressTime = null;
            this.picking = true;

            new RuntimeDropPicker(this.rootDrop).pick()
                .done(this.handleSelection.bind(this));
        } else {
            this.presses++;
            this.previousKeyPressTime = keyPressTime;
        }
    };

    IssueTracking.prototype.handleSelection = function (selection) {
        this.picking = false;

        if (selection) {
            var url = this.configuration.createUrl + '?' + $.param({
                morphId: selection.morphId,
                rootMorphId: selection.rootMorphId,
                identifier: this.configuration.identifier
            });
            window.open(url);
        }
    };

    return IssueTracking;
});
